"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LootTable_1 = __importDefault(require("../../../../structures/LootTable"));
const SimpleMonster_1 = __importDefault(require("../../../../structures/SimpleMonster"));
const HerbDropTable_1 = __importDefault(require("../../../subtables/HerbDropTable"));
const RareDropTable_1 = __importStar(require("../../../subtables/RareDropTable"));
const ChaosElementalMinorTable = new LootTable_1.default()
    .add('Anchovy pizza', 3)
    .add('Babydragon bones', 2)
    .add('Bat bones', 5)
    .add('Big bones', 3)
    .add('Bones', 4)
    .add('Dragon bones')
    .add('Super attack(4)')
    .add('Super defence(4)')
    .add('Super strength(4)')
    .add('Tuna', 5);
const ChaosElementalTable = new LootTable_1.default()
    .every(ChaosElementalMinorTable, 1)
    .tertiary(200, 'Clue scroll (elite)')
    .tertiary(300, 'Pet chaos elemental')
    .oneIn(256, 'Dragon pickaxe')
    /* Weapons and armour */
    .add('Dragon dagger', 1, 11)
    .add('Dragon 2h sword', 1, 1)
    /* Runes and ammunition */
    .add('Air rune', 500, 10)
    .add('Blood rune', 75, 10)
    .add('Chaos rune', 250, 10)
    .add('Death rune', 125, 10)
    .add('Mithril dart', 300, 10)
    .add('Rune arrow', 150, 10)
    /* Other */
    .add('Strange fruit', 10, 13)
    .add('Antidote++(4)', 1, 10)
    .add('Weapon poison(++)', 1, 10)
    .add('Coins', 7500, 8)
    /* Subtables */
    .add(HerbDropTable_1.default, 1, 4)
    .add(RareDropTable_1.default, 1, 8)
    .add(RareDropTable_1.GemTable, 1, 3);
exports.default = new SimpleMonster_1.default({
    id: 2054,
    name: 'Chaos Elemental',
    table: ChaosElementalTable,
    aliases: ['chaos ele', 'chaos elemental', 'chaos el']
});
//# sourceMappingURL=ChaosElemental.js.map